import Dexie, { Transaction } from "dexie";
import { IDatabaseUpgrade } from "../database-upgrade";
import { StoredCachedService } from "src/app/driver/storage/models/stored-cached-service";
import { StoredPiece } from "src/app/storage/models/stored-orders/stored-piece";

/**
 * Defines the upgrade path for version 17 of indexed DB.
 * Converts ClassNumber from number to string for all Hazmat data in CachedServices.
 */
export class DatabaseUpgradeV17 implements IDatabaseUpgrade {
	/** @inheritdoc */
	public readonly Version: number = 17;

	/**
	 * Applies the upgrade to convert ClassNumber values from number to string.
	 * Iterates through all cached services and their pieces, converting any numeric
	 * ClassNumber values to strings while handling edge cases like null, undefined, and zero.
	 *
	 * @inheritdoc
	 */
	public Upgrade(dexieInstance: Dexie): void {
		dexieInstance.version(this.Version).upgrade((transaction: Transaction) => {
			// Convert ClassNumber from number to string in all cached services
			return transaction.table("CachedServices").toCollection().modify((cachedService: StoredCachedService) => {
				if (cachedService.Pieces && cachedService.Pieces.length > 0) {
					cachedService.Pieces.forEach((piece: StoredPiece) => {
						if (piece.Hazmat) {
							// Cast to 'any' because runtime data may still be number type during migration,
							// even though TypeScript definition has been updated to string
							const classNumber = piece.Hazmat.ClassNumber as any;

							// Handle falsy cases - convert to empty string
							if (!classNumber) {
								piece.Hazmat.ClassNumber = '';
							}
							// Handle numeric values - convert to string
							else if (typeof classNumber === 'number') {
								piece.Hazmat.ClassNumber = classNumber.toString();
							}
						}
					});
				}
			});
		});
	}
}
